import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { Form, Input, Button, Card, Typography, Alert, Space } from 'antd'
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons'
import useAuthStore from '../store/authStore'

const { Title, Text } = Typography

const Login = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const login = useAuthStore((state) => state.login)

  const onFinish = async (values) => {
    setLoading(true)
    setError('')

    const result = await login(values.email, values.password)

    if (result.success) {
      navigate('/')
    } else {
      setError(result.error || 'Invalid email or password')
    }
    setLoading(false)
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4"
      style={{
        backgroundImage: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Card
        className="w-full max-w-md shadow-2xl"
        bodyStyle={{ padding: window.innerWidth < 640 ? '1.5rem' : '2rem' }}
      >
        <Space direction="vertical" size="large" className="w-full">
          {/* Logo and Title */}
          <div className="text-center">
            <div className="flex flex-col items-center mb-6">
              <img
                src="/Icon.png"
                alt="ACIS"
                className="w-20 h-20 mb-3"
              />
              <div className="flex flex-col items-center">
                <span className="text-2xl font-bold text-gray-900 mb-1">ACIS</span>
                <span className="text-sm text-gray-600">Alpha Centauri Investment Strategies Inc.</span>
              </div>
            </div>
            <Title level={2} className="mb-0">
              Admin Portal
            </Title>
            <Text type="secondary">Sign in to manage the platform</Text>
          </div>

          {/* Error Alert */}
          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              closable
              onClose={() => setError('')}
            />
          )}

          {/* Login Form */}
          <Form
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please enter your email' },
                { type: 'email', message: 'Please enter a valid email' },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Email"
                autoComplete="email"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: 'Please enter your password' },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item className="mb-0">
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                size="large"
                icon={<LoginOutlined />}
                className="gradient-primary"
              >
                Sign In
              </Button>
            </Form.Item>

            <Form.Item className="mb-0 text-center">
              <Link to="/forgot-password">
                <Button type="link">
                  Forgot Password?
                </Button>
              </Link>
            </Form.Item>
          </Form>

          {/* Footer */}
          <div className="text-center text-gray-500 text-sm">
            <Text type="secondary">
              ACIS AI Platform - Admin Access Only
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  )
}

export default Login
